"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appName = void 0;
exports.appName = 'item';
